// // import React, { useState, useRef, useEffect } from 'react';
// // import Draggable from 'react-draggable';
// // import { ResizableBox } from 'react-resizable';
// // import 'react-resizable/css/styles.css';

// // const FloatingWidget = ({ userDetails, accessToken }) => {
// //   const [open, setOpen] = useState(false);
// //   const [note, setNote] = useState('');
// //   const [rowId, setRowId] = useState('');
// //   const nodeRef = useRef(null);

// //   useEffect(() => {
// //     if (open && accessToken) {
// //       fetch('https://salesjet-10097049716.catalystappsail.com/userdata', {
// //         headers: {
// //           Authorization: `Bearer ${accessToken}`,
// //         },
// //       })
// //         .then(async res => {
// //           const contentType = res.headers.get('content-type');
// //           if (!contentType || !contentType.includes('application/json')) {
// //             throw new Error('Invalid content-type, expected JSON');
// //           }
// //           return res.json();
// //         })
// //         .then(response => {
// //           console.log('API response:', response);
  
// //           const dataArray = Array.isArray(response)
// //             ? response
// //             : Array.isArray(response.data)
// //             ? response.data
// //             : [];
  
// //           const matchedUser = dataArray.find(
// //             item => item.userid === userDetails.UserId
// //           );
  
// //           if (matchedUser) {
// //             setNote(matchedUser.PersonalNotes || '');
// //             setRowId(matchedUser.ROWID || '');
// //           } else {
// //             console.warn('No matching user found');
// //           }
// //         })
// //         .catch(err => {
// //           console.error('Error fetching user data:', err);
// //         });
// //     }
// //   }, [open, accessToken, userDetails.UserId]);

// //   const handleClose = () => {
// //     if (rowId && accessToken) {
// //       const payload = [
// //         {
// //           ROWID: rowId,
// //           PersonalNotes: note,
// //         },
// //       ];
// //       fetch('https://salesjet-10097049716.catalystappsail.com/userdata', {
// //         method: 'PUT', 
// //         headers: {
// //           'Content-Type': 'application/json',
// //           Authorization: `Bearer ${accessToken}`,
// //         },
// //         body: JSON.stringify(payload),
// //       })
// //         .then(res => res.json())
// //         .then(response => {
// //           console.log('Update response:', response);
// //           setOpen(false); 
// //         })
// //         .catch(err => {
// //           console.error('Error updating user data:', err);
// //           setOpen(false); 
// //         });
// //     } else {
// //       console.warn('Missing ROWID or accessToken');
// //       setOpen(false);
// //     }
// //   };

// //   return (
// //     <Draggable nodeRef={nodeRef}>
// //       <div
// //         ref={nodeRef}
// //         style={{
// //           position: 'fixed',
// //           zIndex: 1000,
// //           bottom: 20,
// //           right: 20,
// //           cursor: 'pointer',
// //         }}
// //       >
// //         {!open ? (
// //           <div
// //             onClick={() => setOpen(true)}
// //             style={{
// //               backgroundColor: '#182848',
// //               color: '#fff',
// //               borderRadius: '50%',
// //               width: '50px',
// //               height: '50px',
// //               display: 'flex',
// //               justifyContent: 'center',
// //               alignItems: 'center',
// //               fontSize: '24px',
// //             }}
// //           >
// //             💬
// //           </div>
// //         ) : (
// //           <ResizableBox
// //             width={300}
// //             height={200}
// //             minConstraints={[200, 150]}
// //             maxConstraints={[500, 400]}
// //             resizeHandles={['se']}
// //           >
// //             <div
// //               style={{
// //                 background: '#182848',
// //                 border: '1px solid #ccc',
// //                 borderRadius: '8px',
// //                 padding: '10px',
// //                 color: '#fff',
// //                 height: '100%',
// //                 display: 'flex',
// //                 flexDirection: 'column',
// //               }}
// //             >
// //               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
// //                 <strong>Quick Note</strong>
// //                 <button onClick={handleClose}>✖</button>
// //               </div>
// //               <textarea
// //                 value={note}
// //                 onChange={(e) => setNote(e.target.value)}
// //                 placeholder="Type something..."
// //                 style={{
// //                   flex: 1,
// //                   marginTop: '10px',
// //                   resize: 'none',
// //                   width: '95%',
// //                   borderRadius: '4px',
// //                   padding: '8px',
// //                 }}
// //               />
// //             </div>
// //           </ResizableBox>
// //         )}
// //       </div>
// //     </Draggable>
// //   );
// // };

// // export default FloatingWidget;

import React, { useState, useRef, useEffect } from 'react';
import Draggable from 'react-draggable';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

const FloatingWidget = ({ userDetails, accessToken }) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [rowId, setRowId] = useState('');
  const nodeRef = useRef(null);

  useEffect(() => {
    if (open && accessToken) {
      fetch('https://salesjet-10097049716.catalystappsail.com/userdata', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then(async res => {
          const contentType = res.headers.get('content-type');
          if (!contentType || !contentType.includes('application/json')) {
            throw new Error('Invalid content-type, expected JSON');
          }
          return res.json();
        })
        .then(response => {
          console.log('API response:', response);
  
          const dataArray = Array.isArray(response)
            ? response
            : Array.isArray(response.data)
            ? response.data
            : [];

          const matchedUser = dataArray.find(
            item => item.userId === userDetails?.userId
          );
  
          if (matchedUser) {
            setNote(matchedUser.PersonalNotes || '');
            setRowId(matchedUser.ROWID || '');
          } else {
            console.warn('No matching user found');
          }
        })
        .catch(err => {
          console.error('Error fetching user data:', err);
        });
    }
  }, [open, accessToken, userDetails.UserId]);

  const handleClose = () => {
    if (rowId && accessToken) {
      const payload = [
        {
          ROWID: rowId,
          PersonalNotes: note,
        },
      ];
      fetch('https://salesjet-10097049716.catalystappsail.com/userdata', {
        method: 'PUT', 
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(response => {
          console.log('Update response:', response);
          setOpen(false); 
        })
        .catch(err => {
          console.error('Error updating user data:', err);
          setOpen(false); 
        });
    } else {
      console.warn('Missing ROWID or accessToken');
      setOpen(false);
    }
  };

  return (
    <Draggable nodeRef={nodeRef}>
      <div
        ref={nodeRef}
        style={{
          position: 'fixed',
          zIndex: 1000,
          bottom: 20,
          right: 20,
          cursor: 'pointer',
        }}
      >
        {!open ? (
          <div
            className="note-icon-container"
            onClick={() => setOpen(true)}
            title="Personal Notes"
            style={{
              backgroundColor: '#182848',
              color: '#fff',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '24px',
              position: 'relative',
            }}
          >
            📝
            <span
              className="tooltip"
              style={{
                position: 'absolute',
                bottom: '60px',
                right: '0',
                backgroundColor: '#333',
                color: '#fff',
                textAlign: 'center',
                borderRadius: '4px',
                padding: '5px 10px',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                opacity: 0,
                transition: 'opacity 0.3s ease',
                zIndex: 1001,
                pointerEvents: 'none',
                border: '1px solid red', 
              }}
            >
              Personal Notes
            </span>
          </div>
        ) : (
          <ResizableBox
            width={300}
            height={200}
            minConstraints={[200, 150]}
            maxConstraints={[500, 400]}
            resizeHandles={['se']}
          >
            <div
              style={{
                background: '#182848',
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '10px',
                color: '#fff',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>Quick Note</strong>
                <button onClick={handleClose}>✖</button>
              </div>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Type something..."
                style={{
                  flex: 1,
                  marginTop: '10px',
                  resize: 'none',
                  width: '95%',
                  borderRadius: '4px',
                  padding: '8px',
                }}
              />
            </div>
          </ResizableBox>
        )}
        <style>{`
          .note-icon-container .tooltip {
            opacity: 0;
          }
          .note-icon-container:hover .tooltip {
            opacity: 1;
          }
        `}</style>
      </div>
    </Draggable>
  );
};

export default FloatingWidget;